// extracted by mini-css-extract-plugin
export default {"page":"DashboardPage_page__FSMlJ","bottomGrid":"DashboardPage_bottomGrid__2bqVs"};